<div class='step-header row'>
  <div class="col col-100">
    <h3>Great news, we’re on our way!</h3>
    <p>We’re currently expanding service in your area. Let us know how to get in touch with you, and we'll let you know when Starry is available at your address.</p>
  </div>
</div>

<div class="card-layout no-border text-dark">
  <div class="row">
    <div class="col col-100">
      <label for="address" class="text-center">Your address:</label>
      <div class="your-address">
        <p>{{#formatPlace address }}{{/formatPlace}}</p>
        <a href="/" class="edit-address">Edit&nbsp;Address</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-50 col-100">
      <label for="address-first-name">First Name*</label>
      <input id="address-first-name" value="{{ first_name }}" name="first_name" type="text" autocorrect="off" placeholder="Johnny" autofocus>
    </div>
    <div class="col desktop--col-50 col-100">
      <label for="address-last-name">Last Name*</label>
      <input id="address-last-name" value="{{ last_name }}" name="last_name" type="text" autocorrect="off" placeholder="Appleseed">
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-100 col-100">
      <label for="address-email">Email*</label>
      <input id="address-email" value="{{ email }}" name="email" type="email" autocorrect="off" placeholder="johnny@appleseed.com">
    </div>
  </div>
  <div class="row">
    <input type="submit" class="hidden">
  </div>
</div>
